/**
 * shared-api.js — 공용 데이터 접근 레이어
 * 모든 모듈(자료수집, TM, 가결산)에서 동일한 companies/fps/wms 데이터 참조
 * Single Source of Truth: TM 테이블 기반 /api/shared 엔드포인트 사용
 */

const BASE = '/api/shared';

function getToken() {
  return localStorage.getItem('token') || '';
}

async function request(path) {
  const res = await fetch(BASE + path, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + getToken(),
    },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || '서버 오류');
  return data.data || data;
}

/** 업체 검색 (자동완성용) */
export async function searchCompanies(q) {
  return request('/companies' + (q ? '?q=' + encodeURIComponent(q) : ''));
}

/** FP 검색 (자동완성용) */
export async function searchFps(q) {
  return request('/fps' + (q ? '?q=' + encodeURIComponent(q) : ''));
}

/** WM 검색 */
export async function searchWms(q) {
  return request('/wms' + (q ? '?q=' + encodeURIComponent(q) : ''));
}
